module.exports = __webpack_public_path__ + "img/card-t2.c742b196.png";